import * as React from "react";
import type { SVGProps } from "react";
const SvgTonga = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>{".Tonga_svg__cls-1{fill:#c10000}"}</style>
    </defs>
    <g id="Tonga_svg__Tonga">
      <path d="M0 0h1280v720H0z" className="Tonga_svg__cls-1" />
      <path
        d="M0 0h600v360H0z"
        style={{
          fill: "#fff",
        }}
      />
      <path d="M255 45h90v270h-90z" className="Tonga_svg__cls-1" />
      <path d="M165 135h270v90H165z" className="Tonga_svg__cls-1" />
    </g>
  </svg>
);
export default SvgTonga;
